export class ApplicationEditableFieldApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanFieldsTree() {
    return this.#http.get('/ApplicationEditableField/editable-fields-category-schema');
  }
}
